var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 12 3 C 6.92 3 3 6.72 3 11.73 C 3 14.35 4.07 16.63 5.83 18.18 C 5.97 18.3 6.06 18.5 6.07 18.7 L 6.11 20.3 C 6.15 20.81 6.66 21.14 7.13 20.94 L 8.91 20.15 C 9.07 20.1 9.24 20.07 9.39 20.1 C 10.239 20.343 11.117 20.464 12 20.46 C 17.08 20.46 21 16.74 21 11.73 C 21 6.72 17.08 3 12 3 Z M 17.4 9.71 L 14.76 13.91 C 14.34 14.57 13.44 14.75 12.81 14.25 L 10.71 12.69 C 10.518 12.545 10.252 12.545 10.06 12.69 L 7.2 14.85 C 6.82 15.15 6.33 14.7 6.59 14.29 L 9.23 10.09 C 9.651 9.426 10.545 9.257 11.18 9.72 L 13.28 11.31 C 13.472 11.455 13.738 11.455 13.93 11.31 L 16.78 9.15 C 17.16 8.85 17.65 9.3 17.39 9.71 L 17.4 9.71 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.99a1ebf1b9e7349c6c09a51ea5ffb24d.svg";
export { ForwardRef as ReactComponent };